import dayjs from 'dayjs'

export function huntGroupDate(hunt) {
  const dt = hunt.event_date || hunt.start
  if (!dt) return null
  return dayjs(dt).format('YYYY-MM-DD')
}

export function huntGroupKey(hunt) {
  return hunt.group_key || null
}

export function groupHunts(hunts) {
  const groups = {}
  const ungrouped = []

  hunts.forEach(hunt => {
    const key = huntGroupKey(hunt)
    if (!key) {
      ungrouped.push(hunt)
      return
    }
    if (!groups[key]) {
      groups[key] = []
    }
    groups[key].push(hunt)
  })

  const multiGroups = []
  const singles = [...ungrouped]

  Object.keys(groups).forEach(key => {
    if (groups[key].length >= 2) {
      multiGroups.push({
        key,
        hunts: groups[key],
        city: groups[key][0].city,
        location: groups[key][0].location,
        event_date: groups[key][0].event_date || groups[key][0].start,
      })
    } else {
      singles.push(groups[key][0])
    }
  })

  return { multiGroups, singles }
}

export function huntIsInMultiGroup(hunt, hunts) {
  const key = huntGroupKey(hunt)
  if (!key) return false
  return hunts.filter(h => huntGroupKey(h) === key).length >= 2
}

export function getHuntsInGroup(hunt, hunts) {
  const key = huntGroupKey(hunt)
  if (!key) return []
  return hunts.filter(h => huntGroupKey(h) === key)
}
